import {  
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  } from '@material-ui/core';

  export const PhasenDetails = (props) => {

    //console.log(props.phaseConsumptions)


   const formatnumber = (value) => {
    return value.toFixed(2)
  };

    return (
      <>
        
        <Table size="small">
        <TableHead >
                    <TableRow>
                      <TableCell>
                       Name
                        
                      </TableCell>
                      <TableCell>
                      Leistung (kW)
                       
                      </TableCell>
                      <TableCell>
                      Täglicher Verbrauch (kWh)
                       
                      </TableCell>
                    </TableRow>
                  </TableHead>
        <TableBody>
        {props.phaseConsumptions.map((item, index) => (
            <TableRow key={index} >
             <TableCell>  
            <strong>{item.phaseName}</strong>
            </TableCell> 
            <TableCell>  
            {formatnumber(item.kWPower)} kW
            </TableCell> 
            <TableCell>  
            {formatnumber(item.kWhDaily)} kWh
            </TableCell> 
        </TableRow>
        ))}
        </TableBody>
        </Table>

        
      </>
    )
  }
